/*
 * CartPerformance shim.
 * The theme's product-form.js / cart.js call CartPerformance.* for performance
 * instrumentation, but the upstream cart-performance.js asset was missing from
 * this theme — which made every add-to-cart / cart update throw. This provides
 * the same API (no-op measurements) and, crucially, runs the callback passed to
 * measure() so cart re-rendering still happens.
 */
(function () {
  if (typeof window.CartPerformance !== 'undefined' && window.CartPerformance) return;

  var PREFIX = 'cart-performance';
  function now() {
    try { return performance.now(); } catch (e) { return 0; }
  }

  var CartPerformance = {
    createStartingMarker: function (benchmarkName) {
      try { return performance.mark(PREFIX + ':' + benchmarkName + ':start'); }
      catch (e) { return { name: benchmarkName, startTime: now() }; }
    },
    measureFromMarker: function (benchmarkName, startMarker) {
      try {
        performance.measure(PREFIX + ':' + benchmarkName, {
          start: (startMarker && startMarker.startTime) || 0,
          end: now()
        });
      } catch (e) {}
    },
    measureFromEvent: function (benchmarkName, event) {
      try {
        performance.measure(PREFIX + ':' + benchmarkName, {
          start: (event && event.timeStamp) || 0,
          end: now()
        });
      } catch (e) {}
    },
    measure: function (benchmarkName, callback) {
      var start = now();
      var result = typeof callback === 'function' ? callback() : undefined;
      try { performance.measure(PREFIX + ':' + benchmarkName, { start: start, end: now() }); }
      catch (e) {}
      return result;
    }
  };

  window.CartPerformance = CartPerformance;
})();
